<template>
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <span class="cookie_bar__text">{{$t('cookies.banner.title')}}</span>

                <div class="cookie_bar__buttons">
                    <button class="button--cta" @click="confirm">
                        {{$t('cookies.banner.button_confirm')}}
                    </button>
                    <button class="button--link" @click="gotoInfoPage">
                        {{$t('cookies.banner.button_info')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';

    //TODO style the cookie banner
    @Component
    export default class CookieBanner extends Vue {
        name = 'cookie-banner';

        confirm() {
            this.$emit('confirm');
        }

        gotoInfoPage() {
            console.log('[ CookieBanner ]', 'More info');
            this.$router.push({name: 'cookie-policy'});
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/cookies/CookieBanner.vue